import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import OrderStepsCreationForm from '../../../modules/orderSteps/components/OrderStepsCreationForm';


const OrderStepsCreation = () => {
  const {id} = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const title = id ? t('edit_order_step') : t('create_order_step');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: t('create_order_step'), path: '/order-steps/create-order-step' }],
      page_title: title
    })
  );
  return (
    <div className="page_content order_step_details_page">
      <OrderStepsCreationForm />
    </div>
  );
};

export default OrderStepsCreation;
